import * as ActionTypes from './actionTypes'
import { Record, Map } from 'immutable'
import { FileUploadRecord } from './record'

const State = Record(
  {
    medias: Map(),
    fileUploads: Map(),
  },
  'medias'
)

const MediasReducer = (state = new State(), { type, payload, meta = {} }) => {
  const initialAction = meta.action

  switch (type) {
    case ActionTypes.UPLOAD_FILE_START:
    case ActionTypes.ADD_MEDIA_FILE_TO_NOTE_START:
      return state.update('fileUploads', map =>
        map.set(
          initialAction.meta.uuid,
          new FileUploadRecord({
            uuid: initialAction.meta.uuid,
            uploading: true,
            meta: Map(initialAction.meta.meta),
          })
        )
      )
    case ActionTypes.UPLOAD_FILE_SUCCESS:
    case ActionTypes.ADD_MEDIA_FILE_TO_NOTE_SUCCESS:
      return state.update('fileUploads', map =>
        map.update(initialAction.meta.uuid, fileUpload =>
          fileUpload.merge({
            uploading: false,
            url: payload.url,
            mediaMeta: payload,
          })
        )
      )
    case ActionTypes.UPLOAD_FILE_ERROR:
    case ActionTypes.ADD_MEDIA_FILE_TO_NOTE_ERROR:
      return state.update('fileUploads', map =>
        map.update(initialAction.meta.uuid, fileUpload =>
          fileUpload.merge({
            uploading: false,
            error: payload,
          })
        )
      )
    case ActionTypes.RESET_FILE_UPLOAD:
      return state.deleteIn(['fileUploads', payload.uuid])
    default:
      return state
  }
}

export default MediasReducer
